import * as React from 'react';
import { ActionButton, fetchApi, notifyError, notifyResponse, useCacheRecord } from 'gossamer-front-end';
import { InstitutionMember, InstitutionMemberRow, InstitutionMemberView, UserView } from 'cb-model';
import { Task } from 'gossamer-model';

export interface MemberInviteDeleteButtonProps {
  value: string; // institution_member_id
}

export const UnverifiedMemberAcceptButton: React.FC<MemberInviteDeleteButtonProps> = (props) => {
  const { data, error } = useCacheRecord<InstitutionMemberRow>(InstitutionMember, props.value);
  if (!!error) {
    notifyError(error, 'An error occurred while fetching the follower data');
    return null;
  }
  return (
    <ActionButton
      label="Grant Membership"
      size="sm"
      variant="success"
      waiting={!data}
      execute={async (resetCache) => {
        try {
          const resp = await fetchApi('POST', `/main/institution-member-accept`, {
            institutionMemberId: props.value,
          });
          resetCache(InstitutionMember.id, props.value);
          resetCache(InstitutionMemberView.id);
          resetCache(Task.id);
          resetCache(UserView.id, data.user_id);
          notifyResponse(resp);
        } catch (e) {
          notifyError(e, 'An error occurred while granting membership');
        }
      }}
    />
  );
};
